import {
  token as publicToken,
  jwks as publicJwks,
  tokenInfo as publicTokenInfo,
  userInfo as publicUserInfo,
} from './identity-oauth-v1-refresh-token-oauth.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { BuildRESTFunction, MaybeContext } from '@wix/sdk-types';

export const token: MaybeContext<
  BuildRESTFunction<typeof publicToken> & typeof publicToken
> = /*#__PURE__*/ createRESTModule(publicToken);
export const jwks: MaybeContext<
  BuildRESTFunction<typeof publicJwks> & typeof publicJwks
> = /*#__PURE__*/ createRESTModule(publicJwks);
export const tokenInfo: MaybeContext<
  BuildRESTFunction<typeof publicTokenInfo> & typeof publicTokenInfo
> = /*#__PURE__*/ createRESTModule(publicTokenInfo);
export const userInfo: MaybeContext<
  BuildRESTFunction<typeof publicUserInfo> & typeof publicUserInfo
> = /*#__PURE__*/ createRESTModule(publicUserInfo);

export { SubjectType } from './identity-oauth-v1-refresh-token-oauth.universal.js';
export {
  RefreshToken,
  TokenRequest,
  TokenRequestTenantOneOf,
  InternalTokenResponse,
  InternalTokenResponseResultOneOf,
  TokenResponse,
  TokenErrorResponse,
  TokenInfoRequest,
  TokenInfoResponse,
  AuthorizeRequest,
  RawHttpResponse,
  HeadersEntry,
  RawHttpRequest,
  PathParametersEntry,
  QueryParametersEntry,
  JwksRequest,
  DeviceCodeRequest,
  DeviceCodeResponse,
  DeviceAuthorizeRequest,
  DeviceAuthorizeResponse,
  DeviceVerifyRequest,
  DeviceVerifyResponse,
  DeviceVerifyV2Request,
  DeviceVerifyV2Response,
  DeviceAuthorizationInfoRequest,
  DeviceAuthorizationInfoResponse,
  InvalidateUserCodeRequest,
  InvalidateUserCodeResponse,
  RevokeRefreshTokenRequest,
  RevokeRefreshTokenResponse,
  Empty,
  DomainEvent,
  DomainEventBodyOneOf,
  EntityCreatedEvent,
  RestoreInfo,
  EntityUpdatedEvent,
  EntityDeletedEvent,
  ActionEvent,
  UserDeletedEvent,
  UserBlockedEvent,
  UserInfoRequest,
  UserInfoResponse,
  TokenOptions,
  TokenInfoOptions,
} from './identity-oauth-v1-refresh-token-oauth.universal.js';
export { SubjectTypeWithLiterals } from './identity-oauth-v1-refresh-token-oauth.universal.js';
